import React, { useMemo } from 'react';
import { Heart, IconFormIcons } from 'shared/assets/icons';
import { LifeAreaContextMenu } from 'shared/components/connected/life-area-context-menu';
import { Icon } from 'shared/components/ui/icon';
import { useContextMenuState } from 'shared/hooks/use-context-menu-state';
import { ID } from 'shared/types/id';
import { LifeArea } from 'shared/types/life-area';

import * as Styled from './event.style';
import { EventCard } from './event-card';
import { useTimeBasedStyle } from './use-time-based-style';

export type LifeAreaEventProps = {
  lifeAreaId: ID;
  startDate?: string;
  endDate?: string;
  lifeAreas: LifeArea[];
  onClick?: (id: ID) => void;
  isPast?: boolean;
};

export const LifeAreaEvent: React.FC<LifeAreaEventProps> = ({
  lifeAreaId,
  startDate,
  endDate,
  lifeAreas,
  onClick,
  isPast,
}) => {
  const lifeArea = useMemo(
    () => lifeAreas.find(({ id }) => id === lifeAreaId),
    [lifeAreas, lifeAreaId],
  );

  const {
    open: openMenu,
    close: closeMenu,
    position: menuPosition,
  } = useContextMenuState({
    disabled: !!lifeArea?.frozenAt,
  });

  const { numberOfLines } = useTimeBasedStyle(startDate, endDate);

  const _onClick = () => lifeArea && onClick?.(lifeArea.id);

  if (!lifeArea || !startDate) {
    return null;
  }

  return (
    <>
      <EventCard
        title={lifeArea.name}
        color={lifeArea.color}
        isPast={isPast}
        numberOfLines={numberOfLines}
        onClick={_onClick}
        onContextMenu={openMenu}
        leading={
          <Styled.LeadingSlot
            $color={lifeArea.color ?? undefined}
            $past={isPast}
          >
            <Icon icon={IconFormIcons[lifeArea.iconName] ?? Heart} />
          </Styled.LeadingSlot>
        }
      />

      {!!menuPosition && (
        <LifeAreaContextMenu
          lifeArea={lifeArea}
          onClose={closeMenu}
          location={menuPosition}
        />
      )}
    </>
  );
};
